import { onDomContentLoaded } from '@/helpers';
import { setupCompare } from './compare';
import { setupArticleLinks } from './articles';
import { setupAnalytics } from './analytics';
import { setupResize } from './resize';
import { setupPager } from './pager';
import { hideLastProductIfOnlyOneInRow } from './patches';

export function setupProductGrid() {
    onDomContentLoaded(() => {
        setupCompare();
        setupArticleLinks();
        setupAnalytics();

        if (window.phe.config.responsiveCategoryDump) setupPager();

        setupResize();

        document.querySelector('.product-results-container')?.addEventListener(
            'ajax:after-update', ({ currentTarget, detail: { html } }) => {
                hideLastProductIfOnlyOneInRow();
                document.querySelector('#load-more-component')?.addEventListener(
                    'click', (event) => {
                        event.preventDefault();
                    }
                );

                var newContainer = html.querySelector('.product-results-container');

                if (newContainer) {
                     currentTarget.dataset.ajaxHrefValue = newContainer.dataset.ajaxHrefValue
                }
            }
        );
    })
}
